export class SettingsManagerMock {
    getCommonUserSettings() {}
}
